import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export interface CategorySuggestionRow {
  rowId: string;
  description: string;
  amount: number;
  direction: 'debit' | 'credit';
}

// Mirrors the server's own MAX_ROWS safety net (functions/src/categorySuggestion.ts)
// with headroom -- chunking client-side means a large batch (a big Plaid
// sync, or "suggest for every generic-category transaction") never just
// hits the cap and fails outright. Smaller prompts per call also keep
// each response comfortably under Gemini's output size before JSON
// parsing gets flaky on very long arrays.
const CHUNK_SIZE = 40;

export async function suggestCategories(
  rows: CategorySuggestionRow[],
  existingCategories: string[],
  onProgress?: (done: number, total: number) => void
): Promise<Record<string, string>> {
  const suggest = httpsCallable(functions, 'suggestRowCategories');
  const results: Record<string, string> = {};
  for (let i = 0; i < rows.length; i += CHUNK_SIZE) {
    const chunk = rows.slice(i, i + CHUNK_SIZE);
    const response = await suggest({ rows: chunk, existingCategories }) as { data: { suggestions: Record<string, string> } };
    Object.assign(results, response.data.suggestions);
    onProgress?.(Math.min(i + CHUNK_SIZE, rows.length), rows.length);
  }
  return results;
}
